import { Link } from "@tanstack/react-router"
import type {
  ComponentProps,
  FunctionComponent,
  SVGProps,
} from "react"
import styles from "./PageLink.module.scss"
import { usePolyglot } from "src/contexts"
import type { RoutePath } from "src/types"

export interface Props {
  routePath: RoutePath;
  params?: ComponentProps<typeof Link>["params"];
  search?: Record<string, unknown>;
  polyglotPhraseKey: string;
  Icon: FunctionComponent<SVGProps<SVGElement>>;
  id?: string;
}

export function PageLink(props: Props) {
  const {
    Icon,
    routePath,
    params = {},
    search = {},
    polyglotPhraseKey,
    id,
  } = props

  const polyglot = usePolyglot()

  return (
    <Link
      className={styles.container}
      to={routePath}
      params={params}
      search={search}
      id={id}
    >
      <Icon className={styles.icon} />
      {polyglot.t(polyglotPhraseKey)}
    </Link>
  )
}
